<script setup lang="ts">
interface Recurrence {
  id?: string | null
  dateTimeStart: string
  dateTimeEnd: string
}

interface RoomRef {
  id: string
  title: string
  slug: string
}

interface PersonRef {
  id: string
  title: string
  slug: string
}

interface ProgrammeData {
  id: string
  title: string
  slug: string
  recurrences: Recurrence[]
  ticketUrl?: string | null
  ticketUrlLabel?: string | null
  type?: { id: string; title: string; slug: string } | null
  rooms?: RoomRef[]
  people?: PersonRef[]
  content?: any[]
}

const props = defineProps<{
  programme: ProgrammeData
}>()
</script>

<template>
  <div>
    <div class="m-1">
      <div class="text-lg mb-1">
        <h1>
          {{ programme.title }}
        </h1>

        <ul v-if="programme.recurrences?.length">
          <li
            v-for="(recurrence, index) in getFormattedRecurrences(programme.recurrences)"
            :key="index"
          >
            {{ recurrence }}
          </li>
        </ul>

        <a
          v-if="programme.ticketUrl"
          :href="programme.ticketUrl"
          target="_blank"
          rel="noopener noreferrer"
          class="button mt-0_5 inline-block"
        >
          {{ programme.ticketUrlLabel || $t('labels.tickets') }}
        </a>
      </div>

      <div
        v-if="programme.image?.id"
        class="container-d"
      >
        <core-image
          :image="programme.image"
        />
      </div>

      <div 
        v-if="programme.people?.length"
        class="mb-3 mt-3"
      >
        <div class="mb-1 text-md">{{ $t('labels.exploreTheArtists') }}</div>
        <ul>
          <li v-for="person in programme.people" :key="person.id">
            <shared-person-link :name="person.title" :slug="person.slug" class="text-md" />
          </li>
        </ul>
      </div>

      <template v-if="programme.content?.length">
        <shared-block
          v-for="block in programme.content"
          :key="block.id"
          :block="block"
          :no-horizontal-padding="true"
        />
        <!-- title my-2 -->
      </template>

      <div 
        v-if="programme.rooms?.length"
        class="text-md"
      >
        <div class="mb-1">{{ $t('labels.rooms') }}</div>
        <ul> 
          <li v-for="room in programme.rooms" :key="room.id">
            <site-link
              :route-object="{ name: 'rooms-slug', params: { slug: room.slug } }"
              class="text-hover-accent"
            >
              {{ room.title }}
            </site-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
